import {
    FETCH_DESCRIPTION,
    FETCH_DESCRIPTION_START,
    FETCH_DESCRIPTION_SUCCESS,
    FETCH_DESCRIPTION_ERROR,
    TOGGLE_DESCRIPTION_COLLAPSE,
    TOGGLE_DESCRIPTION_EDIT,
    OPEN_DESCRIPTION_EDIT,
    CLOSE_DESCRIPTION_EDIT,
    SET_DESCRIPTION_OBJ,
    SET_DESCRIPTION,
    TOGGLE_RISK,
    SAVE_DESCRIPTION,
    SAVE_DESCRIPTION_ERROR,
  } from './constants'

const toggleDescriptionCollapse = () => ({ type: TOGGLE_DESCRIPTION_COLLAPSE }) 
const toggleDescriptionEdit = () => ({ type: TOGGLE_DESCRIPTION_EDIT }) 
const openDescriptionEdit = () => ({ type: OPEN_DESCRIPTION_EDIT }) 
const closeDescriptionEdit = () => ({ type: CLOSE_DESCRIPTION_EDIT })
const setDescriptionObj = (obj) => ({ type: SET_DESCRIPTION_OBJ, obj })
const setDescription = (value) => ({ type: SET_DESCRIPTION, value })
const toggleRisk = () => ({ type: TOGGLE_RISK })

const fetchDescription = (id) => ({ type: FETCH_DESCRIPTION, id })
const fetchDescriptionStart = () => ({ type: FETCH_DESCRIPTION_START })
const fetchDescriptionSuccess = () => ({ type: FETCH_DESCRIPTION_SUCCESS })
const fetchDescriptionError = (error) => ({ type: FETCH_DESCRIPTION_ERROR, error })

const saveDescription = (payload) => ({ type: SAVE_DESCRIPTION, payload })
const saveDescriptionError = (error) => ({ type: SAVE_DESCRIPTION_ERROR, error })

export {
    fetchDescription,
    fetchDescriptionStart,
    fetchDescriptionSuccess,
    fetchDescriptionError,
    toggleDescriptionCollapse,
    toggleDescriptionEdit,
    openDescriptionEdit,
    closeDescriptionEdit,
    setDescriptionObj,
    setDescription,
    toggleRisk,
    saveDescription,
    saveDescriptionError,
  }
  